import { FilterSidebarItem } from "@/types";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    alertNotification: {
      active: false,
      message: null,
      color: null,
      icon: null,
      title: null,
    },
    currentFilter: "",
    loadingDialog: false,
    isReturn: false,
    classModal: "",
    lastTab: 0,
    positionY: 0,
    lastItemsPost: [],
    lastItemsUser: [],
    filterPost: {
      interest: [],
      event: [],
      date: {
        type: "YEAR",
        id: 0,
      },
      community: [],
      query: "",
      type: {
        type: "",
        id: 0,
      },
    },
    filterUser: {
      query: "",
      interest: [],
      event: [],
      community: [],
    },
    lastPage: 0,
    lastRoute: "",
    lastParams: {} as Record<string, any>,
    navigationStack: [] as Array<{
      name: string;
      params?: Record<string, any>;
      query?: Record<string, any>;
    }>,
    isGoingBack: false,
    typePost: "",
    filterInput: "",
    routeAfterLogin: {
      name: "",
      params: {},
    },
    lastCardGroupId: 0,
    selectedEvent: [] as FilterSidebarItem[],
    selectedLounge: [] as FilterSidebarItem[],
    miniSidebarValue: false,
    currentTabFourNetwork: 0,
    lastPageFiltered: 0,
    lastItemsPostFiltered: [],
    moderationIsExpanded: false,
    userIsExpanded: false,
    advertIsExpanded: false,
    metricsIsExpanded: false,
    searchState: {
      isReturn: false,
      lastTab: 0,
      positionY: 0,
      searchQuery: "",
      postItems: [] as any[],
      userItems: [] as any[],
      companyItems: [] as any[],
      filterPost: {
        interest: [] as any[],
        event: [] as any[],
        community: [] as any[],
        date: { type: "YEAR", id: 0 },
        type: { type: "", id: 0 },
        query: "",
      },
      filterUser: {
        query: "",
        interest: [] as any[],
        event: [] as any[],
        community: [] as any[],
      },
      filterCompany: {
        query: "",
        interest: [] as any[],
        event: [] as any[],
        community: [] as any[],
      },
      lastPage: 0,
    },
  },
  getters: {},
  mutations: {
    setAlertNotification(state, payload): void {
      state.alertNotification = payload;
      setTimeout(() => {
        state.alertNotification.active = false;
      }, 5000);
    },
    setCurrentFilter(state, payload): void {
      state.currentFilter = payload;
    },
    setLoadingDialog(state, payload): void {
      state.loadingDialog = payload;
    },
    setIsReturn(state, payload): void {
      state.isReturn = payload;
    },
    setClassModal(state, payload) {
      state.classModal = payload;
    },
    setLastTab(state, payload) {
      state.lastTab = payload;
    },
    setPositionY(state, payload) {
      state.positionY = payload;
    },
    setLastItemsPost(state, payload) {
      state.lastItemsPost = payload;
    },
    setLastItemsUser(state, payload) {
      state.lastItemsUser = payload;
    },
    setFilterPost(state, payload) {
      state.filterPost = payload;
    },
    setFilterUser(state, payload) {
      state.filterUser = payload;
    },
    setLastPage(state, payload) {
      state.lastPage = payload;
    },
    setLastRoute(state, payload) {
      state.lastRoute = payload;
    },
    setLastParams(state, payload: Record<string, any>) {
      state.lastParams = payload;
    },
    pushNavigation(
      state,
      route: {
        name: string;
        params?: Record<string, any>;
        query?: Record<string, any>;
      }
    ) {
      state.navigationStack.push(route);
      if (state.navigationStack.length > 50) {
        state.navigationStack.shift();
      }
    },
    popNavigation(state) {
      state.navigationStack.pop();
    },
    setGoingBack(state, payload: boolean) {
      state.isGoingBack = payload;
    },
    clearNavigationStack(state) {
      state.navigationStack = [];
    },
    setTypePost(state, payload) {
      state.typePost = payload;
    },
    setFilterInput(state, payload): void {
      state.filterInput = payload;
    },
    setRouteAfterLogin(state, payload) {
      state.routeAfterLogin = payload;
    },
    setLastCardGroupId(state, payload) {
      state.lastCardGroupId = payload;
    },
    setSelectedEvent(state, payload: FilterSidebarItem[]) {
      // Usando Vue.set para garantir reatividade completa
      Vue.set(
        state,
        "selectedEvent",
        Array.isArray(payload) ? [...payload] : []
      );
    },
    setSelectedLounge(state, payload: FilterSidebarItem[]) {
      // Usando Vue.set para garantir reatividade completa
      Vue.set(
        state,
        "selectedLounge",
        Array.isArray(payload) ? [...payload] : []
      );
    },
    setMiniSidebarValue(state, payload): void {
      state.miniSidebarValue = payload;
    },
    setAlertNotificationStatus(state): void {
      state.alertNotification.active = false;
    },
    setCurrentTabFourNetwork(state, payload): void {
      state.currentTabFourNetwork = payload;
    },
    setLastPageFiltered(state, payload): void {
      state.lastPageFiltered = payload;
    },
    setLastItemsPostFiltered(state, payload): void {
      state.lastItemsPostFiltered = payload;
    },
    setModerationIsExpanded(state, payload): void {
      state.moderationIsExpanded = payload;
    },
    setUserIsExpanded(state, payload): void {
      state.userIsExpanded = payload;
    },
    setAdvertIsExpanded(state, payload): void {
      state.advertIsExpanded = payload;
    },
    setMetricsIsExpanded(state, payload): void {
      state.metricsIsExpanded = payload;
    },
    setSearchState(state, payload): void {
      state.searchState = Object.assign({}, state.searchState, payload);
    },
    setSearchIsReturn(state, payload): void {
      state.searchState.isReturn = payload;
    },
  },
  actions: {
    showAlertNotification({ commit }, payload): void {
      payload.active = true;
      commit("setAlertNotification", payload);
    },
    updateFilter({ commit }, payload: string): void {
      commit("setCurrentFilter", payload);
    },
    hideLoadingIndicator({ commit }): void {
      commit("setLoadingDialog", false);
    },
    updateReturn({ commit }, payload: boolean): void {
      commit("setIsReturn", payload);
    },
    updateClassModal({ commit }, payload): void {
      commit("setClassModal", payload);
    },
    updateLastTab({ commit }, payload): void {
      commit("setLastTab", payload);
    },
    updatePositionY({ commit }, payload): void {
      commit("setPositionY", payload);
    },
    updateLastItemsPost({ commit }, payload): void {
      commit("setLastItemsPost", payload);
    },
    updateLastItemsUser({ commit }, payload): void {
      commit("setLastItemsUser", payload);
    },
    updateFilterPost({ commit }, payload): void {
      commit("setFilterPost", payload);
    },
    updateFilterUser({ commit }, payload): void {
      commit("setFilterUser", payload);
    },
    updateLastPage({ commit }, payload): void {
      commit("setLastPage", payload);
    },
    updateLastRoute({ commit }, payload): void {
      commit("setLastRoute", payload);
    },
    updateLastParams({ commit }, payload: Record<string, any>): void {
      commit("setLastParams", payload);
    },
    updateIsGoingBack({ commit }, payload: boolean): void {
      commit("setGoingBack", payload);
    },
    updateTypePost({ commit }, payload): void {
      commit("setTypePost", payload);
    },
    updateSelectedEvent({ commit }, payload): void {
      commit("setSelectedEvent", payload);
    },
    updateSelectedLounge({ commit }, payload): void {
      commit("setSelectedLounge", payload);
    },
    updateFilterInput({ commit }, payload: string): void {
      commit("setFilterInput", payload);
    },
    updateRouteAfterLogin({ commit }, payload): void {
      commit("setRouteAfterLogin", payload);
    },
    updateLastCardGroupId({ commit }, payload): void {
      commit("setLastCardGroupId", payload);
    },
    updateMiniSidebarValue({ commit }, payload: boolean): void {
      commit("setMiniSidebarValue", payload);
    },
    updateAlertNotificationStatus({ commit }): void {
      commit("setAlertNotificationStatus");
    },
    updateCurrentTabFourNetwork({ commit }, payload): void {
      commit("setCurrentTabFourNetwork", payload);
    },
    updateLastPageFiltered({ commit }, payload): void {
      commit("setLastPageFiltered", payload);
    },
    updateLastItemsPostFiltered({ commit }, payload): void {
      commit("setLastItemsPostFiltered", payload);
    },
    updateModerationIsExpanded({ commit }, payload): void {
      commit("setModerationIsExpanded", payload);
    },
    updateUserIsExpanded({ commit }, payload): void {
      commit("setUserIsExpanded", payload);
    },
    updateAdvertIsExpanded({ commit }, payload): void {
      commit("setAdvertIsExpanded", payload);
    },
    updateMetricsIsExpanded({ commit }, payload): void {
      commit("setMetricsIsExpanded", payload);
    },
    updateSearchReturn({ commit }, payload): void {
      commit("setSearchIsReturn", payload);
    },
    updateSearchState({ commit }, payload): void {
      commit("setSearchState", payload);
    },
  },
  modules: {},
});
